import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import NumberUtilsLib from 'utils/NumberUtils.vue'
import AnimatedInteger from 'animated-number-vue'
import { firebase } from '@firebase/app'
const { Timestamp } = firebase.firestore
const DEFAULT_FILTER = [['@deleted', '==', false], ['type', '==', 'Staff'], ['company', '==', 'nafoodsTayBac']]
export default {
  name: 'StaffStatistics',
  components: {
    'apexchart': VueApexCharts,
    AnimatedInteger
  },
  props: {
    'backLink': {
      type: [String, Object],
      default: '/human-resources'
    },
    companyDefault: {
      type: String,
      default: 'all'
    }// },
    // workingStatusDefault: {
    //   type: String,
    //   default: 'all'
    // }
  },
  data() {
    return {
      filterConfig: {
        company: {
          data: this.companyDefault,
          config: {
            inline: true,
            datasource: {
              options: [
                {
                  label: 'Toàn tập đoàn',
                  value: 'all'
                },
                {
                  label: 'Nafoods Group',
                  value: 'nafoodsGroup'
                },
                {
                  label: 'CL Tây Nguyên',
                  value: 'taynguyen'
                },
                {
                  label: 'Nafoods Miền Nam',
                  value: 'nafoodsMienNam'
                },
                {
                  label: 'Naprod',
                  value: 'naprod'
                },
                {
                  label: 'Chanh leo Nafoods',
                  value: 'nafoods'
                },
                {
                  label: 'Nafoods Tây Bắc',
                  value: 'nafoodsTayBac'
                }
              ]
            }
          }
        },
        // workingStatus: {
        //   data: this.workingStatusDefault,
        //   config: {
        //     inline: true,
        //     datasource: {
        //       options: [
        //         {
        //           label: 'Tất cả',
        //           value: 'all'
        //         },
        //         {
        //           label: 'Đang làm việc',
        //           value: 'working'
        //         },
        //         {
        //           label: 'Thử việc',
        //           value: 'probation'
        //         },
        //         {
        //           label: 'Học việc',
        //           value: 'apprentice'
        //         },
        //         {
        //           label: 'Đã nghỉ việc',
        //           value: 'leave'
        //         }
        //       ]
        //     }
        //   },
        //   show: true
        // }
      },  
      chartConfig: {
        sum: 0,
        company: {
          config: {
            //labels: [],//["Chanh leo Nafoods", "Nafoods Group", "Nafoods Miền Nam", "Nafoods Tây Bắc","Naprod","CL Tây Nguyên"],
            chart: {
              toolbar: {
                show: false
              }
            },
            plotOptions: {
              bar: {
                  horizontal: true,
              }
            },
            theme: {
              mode: 'light', 
              palette: 'palette1', 
            },

            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                return NumberUtilsLib.thousandSeprator(val)
              },
              style: {
                fontSize: '15px'
              }
            },
            // legend: {
            //   fontSize: '18px',
            //   showForSingleSeries: true,
            //   position: 'top'
            // },
            tooltip: {
              enabled: true,
              x: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              y: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              z: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              }
            }
          },
          data: [{
            name: 'Số lượng nhân viên',
            data: []
          }]
        },
        gender: {    
          config: {
            title: {
              text: "Tỉ lệ Nam/Nữ",
              align: "center",
              style: {
                fontSize:  '24px'
              },
            },
            labels: [],
            colors: ["#0000ff","#ff6781"],
            fill: {
              colors: ["#0000ff","#ff6781"]
            },
            theme: {
              mode: 'light', 
              palette: 'palette1', 
            },
            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                return NumberUtilsLib.thousandSeprator(val.toFixed(2)) + ' %'
              },
              style: {
                fontSize: '15px'
              }
            },
            legend: {
              fontSize: '18px',
              showForSingleSeries: true,
              position: 'top'
            },
            tooltip: {
              enabled: true,
              x: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              y: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              z: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              }
            },
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'top'
                }
              }
            }]
          },
          data: []
        },
        age: {    
          config: {
            labels: ["18-29", "30-39","40-49","Trên 50"],
            title: {
              text: "Độ tuổi",
              align: "center",
              style: {
                fontSize:  '24px'
              },
            },
            colors: ['#0091ea', '#00c853', '#ffd600', '#c592a5', '#d500f9', '#ef5350'],
            fill: {
              colors: ['#0091ea', '#00c853', '#ffd600', '#c592a5', '#d500f9', '#ef5350']
            },
            theme: {
              mode: 'light', 
              palette: 'palette1', 
            },
            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                return NumberUtilsLib.thousandSeprator(val.toFixed(2)) + ' %'
              },
              style: {
                fontSize: '15px'
              }
            },
            legend: {
              fontSize: '18px',
              showForSingleSeries: true,
              position: 'top'
            },
            tooltip: {
              enabled: true,
              x: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              y: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              z: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              }
            },
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'top'
                }
              }
            }]
          },
          data: []
        },
        form:{    
          config: {
            title: {
              text: "Hình thức lao động",
              align: "center",
              style: {
                fontSize:  '24px'
              },
            },
            labels: ["Trực tiếp", "Gián tiếp"],
            colors: ['#0091ea', '#00c853', '#ffd600', '#f48fb1', '#d500f9', '#ef5350'],
            fill: {
              colors: ['#0091ea', '#00c853', '#ffd600', '#f48fb1', '#d500f9', '#ef5350']
            },
            theme: {
              mode: 'light', 
              palette: 'palette1', 
            },
            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                return NumberUtilsLib.thousandSeprator(val) + ' %'
              },
              style: {
                fontSize: '15px'
              }
            },
            legend: {
              fontSize: '18px',
              showForSingleSeries: true,
              position: 'top'
            },
            tooltip: {
              enabled: true,
              x: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              y: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              z: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              }
            },
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'top'
                }
              }
            }]
          },
          data: [25, 15]
        },
        position: {    
          config: {
            title: {
              text: "Cấp bậc",
              align: "center",
              style: {
                fontSize:  '24px'
              },
            },
            labels: ["Trực tiếp", "Gián tiếp"],
            colors: ['#0091ea', '#00c853', '#ffd600', '#f48fb1', '#d500f9', '#ef5350'],
            fill: {
              colors: ['#0091ea', '#00c853', '#ffd600', '#f48fb1', '#d500f9', '#ef5350']
            },
            theme: {
              mode: 'light', 
              palette: 'palette1', 
            },
            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                return NumberUtilsLib.thousandSeprator(val) + ' %'
              },
              style: {
                fontSize: '15px'
              }
            },
            legend: {
              fontSize: '18px',
              showForSingleSeries: true,
              position: 'top'
            },
            tooltip: {
              enabled: true,
              x: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              y: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              },
              z: {
                formatter: (value) => {
                  return NumberUtilsLib.thousandSeprator(value)
                }
              }
            },
            responsive: [{
              breakpoint: 400,
              options: {
                legend: {
                  position: 'top'
                }
              }
            }]
          },
          data: [25, 15]
        },
        degree: {
          sort: ["Tiến sĩ","Thạc sĩ", "Đại học","Cao đẳng", "Trung cấp","LĐPT", "Học nghề","n/a"],
          config: {
            colors: ["#0000ff","#ff6781"],
            title: {
              text: "Học vị",
              align: "center",
              style: {
                fontSize:  '24px'
              },
            },
            chart: {
              stacked: true,
              toolbar: {
                show: false
              }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                },
            },
            // legend: {
            //     position: 'right',
            //     offsetY: 40
            // },
            fill: {
                opacity: 1
            },
          },
          data: [] 
        }
      },
      queryConditions: {
        ref: ['Statistics'],
        filter: DEFAULT_FILTER,
        // order: DEFAULT_ORDER,
        limit: 20,
        returnSnapshot: true 
      },
      rawData: null,
      show: false,
      showCompanyChart: true,
      moment,
    }
  },
  created() {
    // // Default product
    // if(!this.hideGroupDep) {
    //   this.filterConfig.group.config.datasource.options.unshift({
    //     label: 'Kênh',
    //     value: 'department'
    //   })
    //   this.chartConfig.main = this._.cloneDeep(this.chartConfig.department.config)
    // } else {
    //   this.chartConfig.main = this._.cloneDeep(this.chartConfig.product.config)
    // }
    // this.chartConfig.main = this._.cloneDeep(this.chartConfig.product.config)
  },
  async mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      let vm = this
      this.show = false
      // vm.$root.$children[0].$refs['top-loadding-bar'].start()
      this.queryConditions.filter = this.buildQuery()
      this.$query(['Statistics'], this.queryConditions.filter).then(res => {
        this.rawData = res.data
        let data = vm._.flatten(res.data.map(item => item.data))
        vm.generateChartData(data)
        // vm.$root.$children[0].$refs['top-loadding-bar'].stop()
        this.show = true
      })
    },
    buildQuery() {
      let defaultFilter = DEFAULT_FILTER
      if(this.filterConfig.company.data && this.filterConfig.company.data !== 'all') {
        defaultFilter = this.R.concat(defaultFilter, [['company', '==', this.filterConfig.company.data]])
      }
      return defaultFilter
    },
    
    numberFormat(value) {
      return NumberUtilsLib.thousandSeprator(value)
    },
    generateChartData(data) {
      let vm = this
      vm.chartConfig.sum = this._.sum(data.map(item => item['noOfStaff']))
      let genderSum = vm._.groupBy(data,'gender');
      let genderHeader = Object.keys(genderSum);
      
      vm.chartConfig.gender.config.labels = genderHeader.map( item => item == 'true' ? 'Nam' : 'Nữ');
      vm.chartConfig.gender.data = genderHeader.map( item => vm._.sumBy(genderSum[item],'noOfStaff'))
      
      let groupAgeSum = vm._.groupBy(data,'groupAge');
      let groupAgeHeader = Object.keys(groupAgeSum);
      groupAgeHeader = groupAgeHeader.sort( (a,b) => parseInt(a.match(/\d+/)[0]) - parseInt(b.match(/\d+/)[0]) )
      vm.chartConfig.age.config.labels = groupAgeHeader
      vm.chartConfig.age.data = groupAgeHeader.map( item => vm._.sumBy(groupAgeSum[item],'noOfStaff'))
     
      let formSum = vm._.groupBy(data,'workTypeName');
      formSum = vm._.mapKeys(formSum, (val,key) => key === '' ? 'n/a' : key )
      
      let formHeader = Object.keys(formSum);
      //formHeader = groupAgeHeader.sort( (a,b) => parseInt(a.match(/\d+/)[0]) - parseInt(b.match(/\d+/)[0]) )

      vm.chartConfig.form.config.labels = formHeader
      vm.chartConfig.form.data = formHeader.map( item => vm._.sumBy(formSum[item],'noOfStaff'))
      
      let positionSum = vm._.groupBy(data,'levelName');
      positionSum = vm._.mapKeys(positionSum, (val,key)  => key === '' ? 'n/a' : key )
      let positionHeader = Object.keys(positionSum);
      positionHeader = positionHeader.sort( (a,b) => vm._.sumBy(positionSum[b],'noOfStaff') - vm._.sumBy(positionSum[a],'noOfStaff') )
      vm.chartConfig.position.config.labels = positionHeader
      vm.chartConfig.position.data = positionHeader.map( item => vm._.sumBy(positionSum[item],'noOfStaff'))


      //companyName
      if (vm.showCompanyChart) {
        let companySum = vm._.groupBy(data,'companyName');
        companySum = vm._.mapValues(companySum, item => vm._.sumBy(item,'noOfStaff'));

        let companyHeader = Object.keys(companySum);
        companyHeader = companyHeader.sort( (a,b) => companySum[a] - companySum[b] )
        vm.chartConfig.company.config.labels = companyHeader
        vm.chartConfig.company.data[0].data = companyHeader.map( item => companySum[item])
      }
      let degreeSum = vm._.groupBy(data,'degreeName');
      degreeSum = vm._.mapKeys(degreeSum, (val,key)  => key === '' ? 'n/a' : key )
      let degreeSumHeader = Object.keys(degreeSum);
      let sortDegree = vm.chartConfig.degree.sort;
      degreeSumHeader = degreeSumHeader.sort( (a,b) => sortDegree.indexOf(a) - sortDegree.indexOf(b) )
      vm.chartConfig.degree.config.labels = degreeSumHeader
      vm.chartConfig.degree.data = genderHeader.map( item => {
        return {
          name: item == 'true' ? 'Nam' : 'Nữ',
          data: degreeSumHeader.map( degree => 
              vm._.sumBy(genderSum[item].filter( e => e.degreeName ===  '' && degree === 'n/a' ? true:  e.degreeName === degree),'noOfStaff')
          )
        }
      })
    },
    changeCompany(data) {
      //this.applyConfigForChart()
      this.fetchData()
      this.showCompanyChart = data === 'all' ? true :  false
    }
  }
}